import Add16 from '@carbon/icons-react/es/add/16';
import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'components/atoms/alert';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { useAccount } from 'hooks/use-account';
import { useTranslation } from 'hooks/use-translation';
import { removeURLProtocols } from 'utils/transform-url';
import { URlRegEx } from 'utils/urls';
import { SettingsLabel } from '../styles';
import { Container } from './styles';

export const AddDomain: FC<{
  onAdd: (domain: string) => void;
  loading: boolean;
}> = ({ onAdd, loading = false }) => {
  const [form] = Form.useForm();
  const buttonText = useTranslation('add');
  const placeholder = useTranslation(
    'settings.email_configuration.create.placeholder',
  );
  const { defaultDomainName } = useAccount();

  const onSubmit = () => {
    const formValues = form.getFieldsValue(true);
    const transformedDomain = removeURLProtocols(formValues.domain);

    return onAdd(transformedDomain);
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Alert
            message={
              <FormattedMessage
                id="settings.email_configuration.create.info"
                values={{
                  defaultDomainName,
                  b: (chunks) => <b>{chunks}</b>,
                  i: (chunks) => <b>{chunks}</b>,
                }}
              />
            }
            showIcon
            type="info"
          />
        </Col>
        <Col xl={24} xxl={12}>
          <Container>
            <SettingsLabel>
              <FormattedMessage id="settings.email_configuration.create.title" />
            </SettingsLabel>
            <Form
              layout="vertical"
              form={form}
              requiredMark={false}
              onFinish={onSubmit}
            >
              <Row>
                <Col flex={12}>
                  <Form.Item
                    name="domain"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        pattern: URlRegEx,
                      },
                    ]}
                    help={
                      <FormattedMessage id="settings.email_configuration.create.validation" />
                    }
                  >
                    <Input placeholder={placeholder} />
                  </Form.Item>
                </Col>
                <Col flex={8}>
                  <Form.Item shouldUpdate>
                    {() => (
                      <Button
                        type="primary"
                        htmlType="submit"
                        icon={<Add16 />}
                        iconPlacement="right"
                        disabled={
                          !form.isFieldsTouched(true) ||
                          !!form
                            .getFieldsError()
                            .filter(({ errors }) => errors.length).length
                        }
                        loading={loading}
                      >
                        {buttonText}
                      </Button>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Container>
        </Col>
      </Row>
    </>
  );
};
